import React, { useRef, useState, VoidFunctionComponent } from 'react';
import Slider, { Settings } from "react-slick";
import { ArrowButton } from "@/components/responsive/commun/arrowButton/ArrowButton";
import { ProductItem } from '@/components/responsive/product/layer/bundle/productItem/ProductItem';
import { BundleOffersGroup } from "@/models/scope/productSheet/promotionalOffers/BundleOffersGroup";
import { BREAKPOINT_DESKTOP } from '@/utils/constants';

interface Props {
  group: BundleOffersGroup;
  isMobile: boolean;
  index: number;
  componentLength: number;
}

export const BundleGroup: VoidFunctionComponent<Props> = ({ group, isMobile, index, componentLength }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  let customSlider = useRef<Slider>(null);

  const { productList, componentId, quantity } = group;
  const sliderOptions: Settings =  {
    dots: productList.length > 3,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    lazyLoad: "ondemand",
    beforeChange: (_, next) => {
      setActiveSlide(next);
    },
    responsive: [
      {
        breakpoint: BREAKPOINT_DESKTOP,
        settings: {
          dots: productList.length > 2,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  
  return (
    <div key={`${componentId}-${index}`} className='groups'>
      <p className='quantity'>
        {parseInt(quantity) === 1
          ? `Choisir ${quantity} produit :`
          : `Choisir ${quantity} produits :`}
      </p>
      <div className='slider'>
        <ArrowButton
          onClick={() => customSlider.current?.slickPrev()}
          isDisable={activeSlide === 0}
          isRotated={true}
        />
        <ArrowButton
          onClick={() => customSlider.current?.slickNext()}
          isDisable={activeSlide >= productList.length - (isMobile ? 2 : 3)}
          isRotated={false}
        />
        <Slider
          ref={(slider) => (customSlider = {
            ...customSlider,
            current: slider,
          })}
          {...sliderOptions}
        >
          {productList.map((product: any) => (
            <ProductItem product={product} key={product.ean13} />
          ))}
        </Slider>
      </div>
      {!!(index < componentLength - 1) && (
        <div className='separator'>
          <img className='plus-icon' src={"/assets/images/responsive/icons/plus-groups.svg"} alt='icone plus' />
        </div>
      )}
    </div>
  );
};
